import "./PhonicComponent.scss";

const PhonicComponent = ({
  phonicText = "",
  phonicArray = [],
  phonicHighlighted,
  setPhonicHighlighted,
}) => {
  if (phonicArray.length == 0) {
    // Swing game
    return (
      <div className="phonic-component">
        <p className={`phonic-component__text`}>{phonicText}</p>
      </div>
    );
  } else {
    // Blending game
    const phonicsJSX = phonicArray.map((phonic, i) => {
      return (
        <p
          key={i}
          className={`phonic-component__text phonic-component__text--alt phonic-component__text--alt${
            i <= phonicHighlighted ? 1 : 0
          }`}
        >
          {phonic}
        </p>
      );
    });
    return (
      <div
        className="phonic-component"
        onClick={() => setPhonicHighlighted(phonicHighlighted + 1)}
      >
        {phonicsJSX}
      </div>
    );
  }
};

export default PhonicComponent;
